import COP from "components/GraphComponents/COPMedium";
import COPSmall from "components/GraphComponents/COPSmall";
import Electricity from "components/GraphComponents/Electricity";
import EnergyBar from "components/GraphComponents/EnergyBar";
import EnergyGraphComp from "components/GraphComponents/EnergyGraphComp";
import { EnergyPiles } from "components/GraphComponents/EnergyPiles";
import PowerStatus from "components/GraphComponents/Status";
import SystemDiagramGraph from "components/GraphComponents/SystemDiagramGraph";
import SystemInfo from "components/GraphComponents/SystemInfo";
import ThermalChange from "components/GraphComponents/ThermalChange";
import { UIComp } from "model/Datatypes";
import React from "react";

export const GraphComponent: React.FC<{ graphComp: UIComp }> = ({ graphComp }) => {
  if (graphComp.type === "COP_Medium")
    return (
      <div className="w-full h-full">
        <COP tags={graphComp.tags} />
      </div>
    );

  if (graphComp.type === "Energy_Graph")
    return (
      <div className="w-full h-full">
        <EnergyGraphComp tags={graphComp.tags} />
      </div>
    );

  if (graphComp.type === "Energy_Bar")
    return (
      <div className="w-full h-full">
        <EnergyBar tags={graphComp.tags} />
      </div>
    );

  if (graphComp.type === "System_Diagram")
    return (
      <div className="w-full h-full relative">
        <SystemDiagramGraph layout={"tall"} tags={graphComp.tags} />
      </div>
    );

  if (graphComp.type === "Power_Status")
    return (
      <div className="w-full h-full">
        <PowerStatus StatusTags={graphComp} screenState={"Dashboard"} />
      </div>
    );

  if (graphComp.type === "System_Info")
    return (
      <div className="w-full h-full">
        <SystemInfo systemInfo={graphComp} />
      </div>
    );

  if (graphComp.type === "Energy_Pile")
    return (
      <div className="w-full h-full">
        <EnergyPiles
          pileTags={graphComp.pileTags}
          metaData={graphComp.metaData}
          tags={graphComp.tags}
        />
      </div>
    );

  if (graphComp.type === "Thermal_Change")
    return (
      <div className="w-full h-full">
        <ThermalChange tags={graphComp} />
      </div>
    );

  if (graphComp.type === "COP_Small")
    return (
      <div className="w-full h-full">
        <COPSmall tags={graphComp} />
      </div>
    );

  if (graphComp.type === "Electricity")
    return (
      <div className="w-full h-full">
        <Electricity tags={graphComp.tags} />
      </div>
    );

  return <div>Could not find graph</div>;
};
